import React from 'react';
import { SettingsHubSection } from '../SettingsHubSection';

const AdminSettingsSection: React.FC = () => (
  <SettingsHubSection section="admin" />
);

export default AdminSettingsSection;
